import { Link } from 'react-router-dom';

export default function LocalServicesHero() {
  return (
    <header className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=friendly%20local%20service%20professional%20in%20uniform%20standing%20confidently%20on%20a%20residential%20street%20in%20a%20sunny%20suburban%20neighborhood%2C%20plumber%20or%20electrician%20with%20tool%20belt%20smiling%20at%20camera%2C%20clean%20van%20parked%20behind%2C%20warm%20golden%20hour%20sunlight%2C%20cinematic%20wide%20angle%20photography%2C%20rich%20warm%20amber%20tones%2C%20no%20text%2C%20high%20contrast%2C%20photorealistic&width=1920&height=1080&seq=ls-hero-bg-01&orientation=landscape"
          alt="Local service professional on the job"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/55 to-black/70" />
      </div>

      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 lg:px-8 text-center pt-28 pb-16">
        <div className="inline-flex items-center gap-2 bg-orange-500/20 border border-orange-500/40 text-orange-300 text-xs font-semibold px-4 py-2 rounded-full mb-8 backdrop-blur-sm">
          <span className="w-1.5 h-1.5 rounded-full bg-orange-400 animate-pulse" />
          Built for Local Service Businesses &amp; Tradespeople
        </div>

        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white leading-tight tracking-tight mb-6">
          AI Ads for Local Services{' '}
          <span className="text-orange-400">That Keep Your Phone Ringing</span>
        </h1>

        <p className="text-lg sm:text-xl text-stone-300 max-w-2xl mx-auto mb-4 leading-relaxed">
          No marketing budget. No agency. No guesswork.{' '}
          <strong className="text-white">AdForge builds your local service advertising</strong> in minutes —
          Facebook ads, Google ads, Instagram ads, all done by AI.
        </p>
        <p className="text-base text-stone-400 max-w-xl mx-auto mb-10">
          Just answer a few questions about your service area and let the AI handle the rest.
          Your first ad is free.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-14">
          <Link
            to="/signup"
            className="px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-bold text-base rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer hover:-translate-y-0.5"
          >
            Generate Your First Ad — It&apos;s Free
          </Link>
          <a
            href="#how-it-works"
            className="px-8 py-4 bg-white/10 hover:bg-white/20 border border-white/20 text-white font-semibold text-base rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            See How It Works
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 sm:gap-10">
          {[
            { value: '4.9★', label: 'Average Rating' },
            { value: '&lt; 3 min', label: 'To Your First Ad' },
            { value: 'Free', label: 'To Start' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div
                className="text-2xl font-black text-white"
                dangerouslySetInnerHTML={{ __html: stat.value }}
              />
              <div className="text-xs text-stone-400 font-medium mt-0.5">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent" />
    </header>
  );
}
